import PacManGame from "Pages/PacManGame";
import HazardPerceptionGame from "Pages/HazardPerceptionGame";
import TermsAndConditions from "Pages/Site/TermsAndConditions";

export default [
    { path: '/pac-man-game', component: PacManGame },
    { path: '/hazard-perception-game', component: HazardPerceptionGame},
    { path: '/terms-and-conditions', component: TermsAndConditions}
];
